export const renderTooltipChecklist = (
  checklist: { label: JSX.Element | string; success: boolean }[],
) => checklist.map(item => <div>{item.label}</div>);
